import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { findSelectedInCategory, removeEmpty } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import fetch, { fetchConfig } from '@/hooks/fetch';
import { roleReassignMessage } from '../helper';
import { fetchDefaultRole, hideRoleReassign, updateUsersRole } from '../actions';
import RoleReassignUsersTable from './RoleReassignUsersTable';
import RoleReassignRolesTable from './RoleReassignRolesTable';

const RoleReassignDialog = ({
  allowConfigurationRead,
  fetchDefault,
  hide,
  reassignUsers,
  roleCode,
  userRoleCodes,
  users,
  theme,
}) => {
  const intl = useIntl();
  fetch.useFetch(fetchDefault, states.NONE, fetchConfig([], () => allowConfigurationRead));
  const saving = () => users.some((result) => result.updateStatus === states.PENDING);

  const minData = () => {
    if (userRoleCodes.length === 1 && roleCode !== null) {
      return userRoleCodes[0] !== roleCode;
    }
    return roleCode !== null;
  };

  return (
    <Dialog
      className="aridhia-role-reassign-dialog smallwizard"
      contentClassName="pt-0"
      icon="drivers license"
      inProgress={saving()}
      message={users.length === 1 ? roleReassignMessage(users[0]) : undefined}
      minimumDataEntryMet={minData()}
      onClose={hide}
      onSave={reassignUsers}
      saveMessageId="users.role.reassign.button"
      size="small"
      theme={theme}
      title={intl.formatMessage({ id: 'users.role.reassign.title' })}
      values={{ userName: users[0].name, roleName: users[0].role?.name }}
    >
      {users.length === 1 && (<RoleReassignRolesTable />)}
      {users.length > 1 && (<RoleReassignUsersTable />)}
    </Dialog>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { configurations: { read } } } },
  roles: { roles },
}) => {
  const items = findSelectedInCategory(roles, 'reassign');
  const { users } = roles.reassign;
  const userRoleCodes = removeEmpty(users.map((u) => u.role?.code)).filter((v, i, a) => a.indexOf(v) === i);

  return ({
    allowConfigurationRead: read,
    roleCode: items.length === 1 ? items[0].code : null,
    users,
    userRoleCodes,
  });
};

const mapDispatchToProps = {
  fetchDefault: fetchDefaultRole,
  hide: hideRoleReassign,
  reassignUsers: updateUsersRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleReassignDialog);
